import type { RouteRecordRaw } from 'vue-router'
import LeagueIndex from '@/views/frontDesk/league/index.vue'
import LeagueTabel from '@/views/frontDesk/league/tabel.vue'
import LeagueMemberTabel from '@/views/frontDesk/league/memberTabel.vue'

// 拎包商加盟
export const LeagueRoute: Array<RouteRecordRaw> = [
  {
    path: 'leagueIndex',
    name: 'LeagueIndex',
    meta: {
      title: '拎包商加盟' 
    },
    component: LeagueIndex
  },
  {
    path: 'leagueIndex/leagueTabel',
    name: 'LeagueTabel',
    meta: {
      title: '非会员加盟申请' 
    },
    component: LeagueTabel
  },
  {
    path: 'leagueIndex/leagueMemberTabel',
    name: 'LeagueMemberTabel',
    meta: {
      title: '会员加盟申请' 
    },
    component: LeagueMemberTabel
  },
]

export default LeagueRoute